'use client'

import * as React from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'
import { cn } from '../../lib/utils'
import { cva, VariantProps } from 'class-variance-authority'

const variants = cva(
  'relative w-full overflow-hidden rounded-full bg-primary/20',
  {
    variants: {
      size: {
        md: 'h-4',
        sm: 'h-2',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
)

/**
 * Progress is used to display the progress status for a task that takes a long time or consists of several steps.
 */
const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    isIndeterminate?: boolean
  } & VariantProps<typeof variants>
>(({ className, value, isIndeterminate, size, ...props }, ref) => {
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        variants({
          size,
        }),
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn('h-full w-full flex-1 bg-primary transition-all', {
          'progress left-right': isIndeterminate,
        })}
        style={{
          transform: !isIndeterminate
            ? `translateX(-${100 - (value || 0)}%)`
            : '',
        }}
      />
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
